'use strict';

import api from '../../utils/api';
import router from '../../router';

// initial state
const state = {
    isLoaded: false,
    filter: '',
    limit: 10,
    page: 1,
    order: 'name',
    totalCount: 0,
    items: [],
    start: 0,
    end: 0,
    canIncrease: false,
    canDecrease: false
};

// mutations
const mutations = {
    clear(state) {
        state.filter = '';
        state.page = 1;
        state.order = 'name';
        state.totalCount = 0;
        state.items = [];

        state.start = 0;
        state.end = 0;
        state.canIncrease = false;
        state.canDecrease = false;
    },
    clearIndices(state) {
        state.page = 1;
        state.start = 0;
        state.end = 0;
        state.canIncrease = false;
        state.canDecrease = false;
    },
    loading(state) {
        state.isLoaded = false;
    },
    loaded(state) {
        state.isLoaded = true;
    },
    recalculatePaging(state) {
        state.start = Math.min((state.page - 1) * state.limit + 1, state.totalCount);
        state.end = Math.min(state.page * state.limit, state.totalCount);
        state.canIncrease = state.page * state.limit < state.totalCount;
        state.canDecrease = state.page > 1;
    },
    filter(state, filter) {
        state.filter = filter;
    },
    page(state, page) {
        state.page = page;
    },
    order(state, order) {
        if (state.order === order) {
            order = '-' + order;
        }
        state.order = order;
    },
    totalCount(state, totalCount) {
        state.totalCount = totalCount;
    },
    items(state, items) {
        state.items = items;
    }
};

// getters
const getters = {
    sortByColumn: (state) => (column) => {
        return column === state.order || column === state.order.substr(1);
    }
};

// functions
const functions = {
    reload(store) {
        store.commit('loading');
        api.post('/api/table/search',
            {
                filter: store.state.filter,
                limit: store.state.limit,
                page: store.state.page,
                order: store.state.order
            }).then(function(response) {
            store.commit('items', response.body.items);
            store.commit('totalCount', response.body.totalCount);
            store.commit('recalculatePaging');
            store.commit('loaded');
        });
    }
};


// actions
const actions = {
    open(store) {
        store.commit('clear');
        functions.reload(store);
    },
    reload(store) {
        functions.reload(store);
    },
    search(store) {
        store.commit('clearIndices');
        functions.reload(store);
    },
    previousPage(store) {
        if (store.state.isLoaded) {
            store.commit('page', store.state.page - 1);
            functions.reload(store);
        }
    },
    nextPage(store) {
        if (store.state.isLoaded) {
            store.commit('page', store.state.page + 1);
            functions.reload(store);
        }
    },
    back() {
        router.push({
            name: 'dashboard'
        });
    },
    setFilter(store, payload) {
        store.commit('filter', payload);
    },
    setOrder(store, payload) {
        store.commit('order', payload);
        functions.reload(store);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/table.js